<template>

  <section class="content">

    <modal title="Désactiver un cantonnier"
           v-on:close="doCloseAnyModals"
           v-if="deleteModal === true">
      <cantonniers-delete slot="body"
                          v-on:close="doCloseAnyModals"
                          :cantonnier="cantonnier"></cantonniers-delete>
    </modal>

    <modal title="Modifier un cantonnier"
           v-on:close="doCloseAnyModals"
           v-if="updateModal === true">
      <cantonniers-form slot="body"
                        v-on:close="doCloseAnyModals"
                        :update-cantonnier="cantonnier"></cantonniers-form>
    </modal>

    <modal title="Créer un cantonnier"
           v-on:close="doCloseAnyModals"
           v-if="createModal === true">
      <cantonniers-form slot="body"
                        v-on:close="doCloseAnyModals"></cantonniers-form>
    </modal>

    <section class="content-toolbar">
      <div class="btn btn-primary"
           v-on:click="clickCreate()">Créer un cantonnier</div>
    </section>

    <cantonniers-list v-on:delete="clickDelete"
                      v-on:edit="clickEdit">
    </cantonniers-list>

  </section>
  
</template>

<script>
import CantonniersList from './CantonniersList'
import CantonniersDelete from './CantonniersDelete'
import CantonniersForm from './CantonniersForm'
import Modal from '../commons/Modal'

export default {
  components: {
    CantonniersList,
    CantonniersDelete,
    CantonniersForm,
    Modal,
  },
  data: function () {
    return {
      deleteModal: false,
      updateModal: false,
      createModal: false,
      cantonnier: null,
    }
  },
  methods: {
    clickDelete: function (cantonnier) {
      this.cantonnier = cantonnier
      this.deleteModal = true
    },
    clickEdit: function (cantonnier) {
      this.cantonnier = cantonnier
      this.updateModal = true
    },
    clickCreate: function () {
      this.createModal = true
    },
    doCloseAnyModals: function () {
      this.deleteModal = false
      this.updateModal = false
      this.createModal = false
    },
  },
}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// Cantonniers.vue?802909f4